import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-http-backend";
import EnNs1 from "./locales/en/en.json";
import TrNs1 from "./locales/tr/tr.json";
export const defaultNS = "common";
export const resources = {
    en: {
        common: EnNs1,
    },
    tr: {
        common: TrNs1,
    },
};
class Localize {
    static LANG_DETECTION_OPTIONS = {
        order: ["querystring", "navigator"],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        caches: ["localStorage", "cookie"],
    };
    static initI18n() {
        const storedLanguage = localStorage.getItem("i18nextLng") || "en";
        if (!["en", "tr"].includes(storedLanguage)) {
            console.log("Unsupported language in localStorage, setting to default English.");
            localStorage.setItem("i18nextLng", "en");
        }
        i18next
            .use(XHR)
            .use(LanguageDetector)
            .init({
            load: "languageOnly",
            debug: false,
            fallbackLng: "en",
            defaultNS: "common",
            ns: ["common"],
            resources,
            interpolation: { escapeValue: false },
            supportedLngs: ["en", "tr"],
            lng: storedLanguage,
            detection: Localize.LANG_DETECTION_OPTIONS,
            retryTimeout: 350,
            maxRetries: 5,
        });
    }
    static init() {
        this.initI18n();
    }
    static translate(key, options) {
        if (typeof key !== "string") {
            throw new Error("Input type for i18next localization must be string.");
        }
        return i18next.t(key, options);
    }
    static changeLanguageViaI18n(buttonId, language) {
        if (!["en", "tr"].includes(language)) {
            console.error(`Language ${language} is not supported.`);
            return;
        }
        const targetBtn = document.getElementById(buttonId);
        if (targetBtn) {
            const oldListener = targetBtn._languageChangeListener;
            if (oldListener) {
                targetBtn.removeEventListener("click", oldListener);
            }
            const newListener = () => {
                if (i18next.language === language) {
                    console.log("Language is already set to target language:", language);
                    return;
                }
                else {
                    localStorage.setItem("i18nextLng", language);
                    window.location.reload();
                }
            };
            targetBtn.addEventListener("click", newListener);
            targetBtn._languageChangeListener = newListener;
        }
        else {
            console.error(`Button ${buttonId} does not exist.`);
            return;
        }
    }
}
export default Localize;
